<div class="project-access-history" [attr.data-automation-id]="automationId + '-container'">
    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [columnDefs]="columnDefs"
        [requestInfo]="requestInfo" [headerTemplate]="projectAccessHistoryHeaderTemplate" [(isBusy)]="isBusy"
        [(isBusyMessage)]="isBusyMessage" [pagerTemplate]="pagerWithDownloadTemplate"
        [responseArrayCallback]="responseArrayCallbackProjectAccessHistoryNodes" [gridContext]="gridContext">
    </res-generic-grid>
    <ng-template #projectAccessHistoryHeaderTemplate>
        <div class='top-bar'>
            <span class="title">Project Access History</span>
            <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
                (click)="openHelp()">
                <i class="fa fa-question"></i>
            </button>
        </div>
    </ng-template>

    <ng-template #pagerWithDownloadTemplate>
        <button type="button" [attr.data-automation-id]="automationId + '-download-button'"
            class="secondary-button icon-button" (click)="downloadProjectAccessHistoryReport()"
            [title]="this.downloadTooltip">
            <i class="fa fa-download color-blue-01"></i>
        </button>
    </ng-template>

    <a download #downloadLink hidden target="_blank"></a>
</div>